import React, { Component } from 'react'
import LockIcon from '@material-ui/icons/Lock';
import logo from '../assets/logowhite.png'
import './index.css'

export class NavCheck extends Component {

    constructor() {
        super()
        this.state = {
            wholeData: '',
        }
    }

    componentDidMount() {
        let headerData = JSON.parse(localStorage.getItem("headerData"))
        this.setState({ wholeData: headerData })
    }

    render() {
        return (
            <header className="navCheck">
                <nav className="navresponsive">
                    <p className="header-empty--secure-checkout">
                        <span className="icon-secure">
                            <LockIcon style={{ fontSize: 18 }} />
                        </span>
                        <font>Safe Shopping</font>
                    </p>
                    <img alt="header" className="header-empty--logo" src={this.state.wholeData.logo_url} style={{ width: 140, height: 39 }} onClick={() => window.location.href = "/"} />
                    <div className="cs-number--top">
                        <a>
                            <strong>Need help?</strong>
                            <br />
                            <font>Call {this.state.wholeData.phone}</font>
                        </a>
                    </div>
                </nav>
            </header>
        )
    }
}

export default NavCheck
